export default "__VITE_ASSET__CMe154D___"